import Bluebird from 'bluebird';

/**
 * Load a script file by injecting a <script> tag.
 *
 * If id is passed, it will be used as the element id.
 * If another element with the same id exists, the script won't be loaded.
 */
export default function importScript(src, id) {
  if (typeof window === 'undefined') { throw new Error('Cannot import scripts on the server'); }

  let script;

  if (id) {
    script = document.getElementById(id);
    if (script) {
      return script.promise || Bluebird.resolve();
    }
  }

  const promise = new Bluebird((resolve, reject) => {
    script = document.createElement('script');
    if (id) { script.id = id; }
    script.async = true;

    script.onload = resolve;
    script.onerror = reject;

    script.src = src;
    script.promise = promise;

    document.getElementsByTagName('head')[0].appendChild(script);
  }).then(
    // cleanup
    () => {
      script.promise = void 0;
    },
    error => {
      script.parentNode.removeChild(script);
      throw error;
    }
  );

  return promise;
}



// WEBPACK FOOTER //
// ./utils/importScript.jsx